module.exports = __WEBPACK_EXTERNAL_MODULE_alpheios_l10n__;